import apiHandler from "../core/apiHandler";

const productSubCategoryApi =
  apiHandler("product-sub-categories");

export default productSubCategoryApi;